// extracted by mini-css-extract-plugin
module.exports = {"link":"CookiesConsent_link__rTL6U","cookiesFooter":"CookiesConsent_cookiesFooter__MUb8_"};